import AnimatedCounter from '@/components/AnimatedCounter';
import ScrollReveal from '@/components/ScrollReveal';

const stats = [
  {
    value: 60,
    suffix: '+',
    label: 'Years Experience',
    description: 'Combined enterprise technology expertise',
  },
  {
    value: 8,
    suffix: '',
    label: 'Core Capabilities',
    description: 'End-to-end AI workflow solutions',
  },
  {
    value: 5,
    suffix: '+',
    label: 'Industries',
    description: 'Deep expertise across regulated sectors',
  },
  {
    value: 24,
    suffix: 'h',
    label: 'Response Time',
    description: 'Fast, founder-led engagement',
  },
];

export default function Stats() {
  return (
    <section className="section-padding bg-white relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-primary/5 opacity-30" />

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <ScrollReveal className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Outcomes & Results
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Measurable impact delivered through production-grade AI systems
          </p>
        </ScrollReveal>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <ScrollReveal key={index} delay={index * 0.1}>
              <div className="text-center group">
                {/* Number */}
                <div className="relative inline-block mb-4">
                  <span className="text-5xl sm:text-6xl font-bold gradient-text">
                    <AnimatedCounter
                      end={stat.value}
                      suffix={stat.suffix}
                      duration={1.5 + index * 0.2}
                    />
                  </span>
                </div>

                {/* Label */}
                <h3 className="text-xl font-semibold text-slate-900 mb-2">
                  {stat.label}
                </h3>

                {/* Description */}
                <p className="text-slate-500 text-sm">{stat.description}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
